import { useLocation } from 'react-router-dom';
import { IUserMe } from 'redux-store/types';

export const useHeaderState = ({ userMe }: { userMe: IUserMe }) => {
  const { pathname } = useLocation();

  const isSelectionsPage =
    pathname.includes('selections') &&
    !pathname.includes('selections-library') &&
    !pathname.includes('selections-template');

  const showHeaderActionButtons =
    pathname.includes('project-dashboard') ||
    isSelectionsPage ||
    pathname.includes('feedbacks') ||
    pathname.includes('gallery');

  const showLogo = [
    'account-dashboard',
    'schedule-template',
    'project-settings',
    'guest-gallery',
  ].some((condition) => pathname.includes(condition));

  const showProfileButtons =
    (pathname.includes('guest-gallery') && !!userMe) || !pathname.includes('guest-gallery');

  return { showHeaderActionButtons, showLogo, showProfileButtons };
};
